import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={27}
    height={25}
    viewBox="0 0 27 25"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#C8D8FF'}
      d="M20.8 24.911c-.37 0-.73-.13-1.01-.37-3.21-2.72-5.05-5.18-5.05-6.75 0-1.16.69-2.2 1.76-2.64.35-.14.71-.21 1.08-.21 1.16 0 2.19.69 2.63 1.76.07.16.19.28.34.34l.07.03.18.02c.26 0 .49-.15.59-.39a2.84 2.84 0 0 1 2.63-1.76c1.57 0 2.84 1.28 2.84 2.84 0 1.56-1.8 3.95-5.05 6.75-.28.24-.64.37-1.01.37v.01Z"
    />
    <Path
      fill={props.fill || '#C8D8FF'}
      d="M5.34 24.5c-2.41 0-4.36-1.96-4.36-4.36V4.68C.98 2.27 2.94.32 5.34.32h6.31c.75 0 1.46.29 1.99.82l2.27 2.27h4.88c2.41 0 4.36 1.96 4.36 4.36v4.25c0 .7-.57 1.27-1.27 1.27-.7 0-1.27-.57-1.27-1.27V7.77c0-1-.82-1.82-1.82-1.82h-4.77c-.75 0-1.46-.29-1.99-.82l-2.27-2.27H5.33c-1 0-1.82.82-1.82 1.82v15.46c0 1 .82 1.82 1.82 1.82h6.96c.7 0 1.27.57 1.27 1.27 0 .7-.57 1.27-1.27 1.27H5.33h.01Z"
    />
  </Svg>
);
export default SvgComponent;
